export default __webpack_public_path__ + "static/media/collaborate3.f81e5ab4.png";